export default "__VITE_PUBLIC_ASSET__5f21cb1d__"